import(/* webpackMode: "eager" */ "/var/www/next-frontend/src/app/not-found.js");
